import mobileCss from '../mobile.css?raw';
import arcoCss from '@arco-design/mobile-react/dist/style.min.css?raw';
import flexibleModule from '@arco-design/mobile-react/tools/flexible';

// Scope through parsed selectors so comma lists and nested media rules retain their meaning.
function scopeRules(rules: CSSRuleList) {
  for (const rule of Array.from(rules)) {
    if ('selectorText' in rule) {
      const style = rule as CSSStyleRule;
      // :is keeps selector lists (including functional commas) intact.
      style.selectorText = `html.portal-mobile :is(${style.selectorText})`;
    } else if ('cssRules' in rule && rule.type !== CSSRule.KEYFRAMES_RULE) {
      scopeRules((rule as CSSGroupingRule).cssRules);
    }
  }
}

export function activateMobileStyles() {
  const root = document.documentElement;
  const fontSize = root.style.getPropertyValue('font-size');
  const fontPriority = root.style.getPropertyPriority('font-size');
  const hadClass = root.classList.contains('portal-mobile');
  const style = document.createElement('style');
  style.dataset.portalMobileStyles = 'true';
  // Arco's reset is scoped separately; prototype root selectors already name the lifecycle class.
  style.textContent = arcoCss;
  document.head.append(style);
  if (style.sheet) scopeRules(style.sheet.cssRules);
  const prototypeStyle = document.createElement('style');
  prototypeStyle.dataset.portalMobileStyles = 'true';
  prototypeStyle.textContent = mobileCss;
  document.head.append(prototypeStyle);
  root.classList.add('portal-mobile');

  const flexibleExport = flexibleModule as unknown;
  const flexible = (typeof flexibleExport === 'function' ? flexibleExport
    : (flexibleExport as { default: unknown }).default) as (base?: number) => () => void;
  const flexibleWindow = window as unknown as { isResponsive?: boolean };
  const resize = () => {
    // Use the helper's synchronous mode with our owned listener: its default mode schedules
    // an uncancellable 30ms resize callback that can overwrite the restored desktop font.
    const wasResponsive = flexibleWindow.isResponsive;
    try {
      flexibleWindow.isResponsive = false;
      const width = Math.min(window.innerWidth || 375, root.clientWidth || window.innerWidth || 375);
      flexible(Math.min(width / 375 * 50, 64));
    } finally {
      if (wasResponsive === undefined) delete flexibleWindow.isResponsive;
      else flexibleWindow.isResponsive = wasResponsive;
    }
  };
  resize();
  window.addEventListener('resize', resize);
  window.addEventListener('orientationchange', resize);
  return () => {
    window.removeEventListener('resize', resize);
    window.removeEventListener('orientationchange', resize);
    style.remove();
    prototypeStyle.remove();
    if (!hadClass) root.classList.remove('portal-mobile');
    if (fontSize) root.style.setProperty('font-size', fontSize, fontPriority);
    else root.style.removeProperty('font-size');
  };
}
